// Shared project gallery categories (matches backend PROJECT_CATEGORIES).
// slug must match exactly what backend accepts.
export const PROJECT_CATEGORIES = [
  {
    slug: "maleri",
    title: "Måleri",
    description:
      "Från väggar och tak till snickerier. Vi använder färg av hög kvalitet för att ge ditt hem en hållbar finish och ny känsla.",
  },
  {
    slug: "renovering",
    title: "Renovering",
    description:
      "Helhetslösningar för hemmet. Från spackling och slipning till slutfinish – vi tar hand om hela projektet.",
  },
  {
    slug: "tapetsering",
    title: "Tapetsering",
    description:
      "Professionell tapetsering med fokus på perfekta skarvar och noggrann mönsterpassning för ett felfritt resultat.",
  },
  {
    slug: "fasad-sockelputs",
    title: "Akrylfasad med Rockwool-isolering & Träfasad",
    description:
      "Skydda ditt hus mot väder och vind. Tilläggsisolering med akrylputs samt renovering och målning av träfasader.",
  },
  {
    slug: "mosaik-marmorsten",
    title: "Mosaik / Sockelputs & Marmorsten",
    description:
      "Dekorativ sockelputs med färgad sten samt marmorsten för stenmattor, trappor och terrassgolv.",
  },
];

export const DEFAULT_CATEGORY = "maleri";

/**
 * Opens the project gallery scrolled to the given category folder.
 * ProjectFolder listens for this event.
 */
export const openGalleryFolder = (slug) => {
  window.dispatchEvent(new CustomEvent("swedcro:open-folder", { detail: { slug } }));
};

export const findCategory = (slug) =>
  PROJECT_CATEGORIES.find((c) => c.slug === slug) || PROJECT_CATEGORIES[0];
